import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from '../login/LoginPage';
import SMSSendingToLead from '../leads/SMSSendingToLead';

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/kshema-app" element={<SMSSendingToLead />} />
    </Routes>
  );
};
